import type { ResolveDistrictResult } from '@citizen-walk/shared-types';
import { createContext, useContext, type ReactNode } from 'react';

export type DistrictState =
  | { status: 'idle' }
  | { status: 'loading' }
  | { status: 'ready'; district: ResolveDistrictResult; source: 'cache' | 'remote' }
  | { status: 'error'; error: Error };

const DistrictContext = createContext<DistrictState | null>(null);

export function DistrictContextProvider({
  value,
  children,
}: {
  value: DistrictState;
  children: ReactNode;
}) {
  return <DistrictContext.Provider value={value}>{children}</DistrictContext.Provider>;
}

/**
 * DistrictProvider 配下なら現在の解決状態を返す。
 * Provider 外 (`/` direct アクセス等) では null。
 */
export function useDistrictState(): DistrictState | null {
  return useContext(DistrictContext);
}
